import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { EpHttpService } from '../../services/epHttpService/epHttp.service';

@Component({
    selector: 'app-ep-loading-screen',
    templateUrl: './ep-loading-screen.component.html',
    styleUrls: ['./ep-loading-screen.component.scss'],
    standalone: false
})
export class EpLoadingScreenComponent implements OnInit, OnDestroy {
  @Input() loadingScreen: boolean;
  private subscription: Subscription;

  constructor(private epHttpService: EpHttpService) { }

  ngOnInit(): void {
    this.subscription = this.epHttpService.loading$.subscribe(
      (isLoading) => {
        if(!isLoading) {
        this.loadingScreen = isLoading;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
